var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1167 12.0748L15.2833 10.6915C15.1083 10.3832 14.95 9.79984 14.95 9.45817V7.34984C14.95 4.63317 12.7417 2.4165 10.0167 2.4165C7.29166 2.4165 5.08333 4.63317 5.08333 7.34984V9.45817C5.08333 9.79984 4.92499 10.3832 4.74999 10.6832L3.90833 12.0748C3.57499 12.6332 3.49999 13.2498 3.70833 13.8165C3.90833 14.3748 4.38333 14.8082 4.99999 15.0165C6.61666 15.5665 8.31666 15.8332 10.0167 15.8332C11.7167 15.8332 13.4167 15.5665 15.0333 15.0248C15.6167 14.8332 16.0667 14.3915 16.2833 13.8165C16.5 13.2415 16.4417 12.6082 16.1167 12.0748Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8748 2.7665C11.2998 2.5415 10.6748 2.4165 10.0165 2.4165C9.3665 2.4165 8.7415 2.53317 8.1665 2.7665C8.52484 2.0915 9.23317 1.6665 10.0165 1.6665C10.8082 1.6665 11.5082 2.0915 11.8748 2.7665Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3581 16.6748C12.0081 17.6415 11.0831 18.3332 9.99978 18.3332C9.34145 18.3332 8.69145 18.0665 8.23311 17.5915C7.96645 17.3415 7.76645 17.0082 7.64978 16.6665C7.75811 16.6832 7.86645 16.6915 7.98311 16.7082C8.17478 16.7332 8.37478 16.7582 8.57478 16.7748C9.04978 16.8165 9.53311 16.8415 10.0164 16.8415C10.4914 16.8415 10.9664 16.8165 11.4331 16.7748C11.6081 16.7582 11.7831 16.7498 11.9498 16.7248C12.0831 16.7082 12.2164 16.6915 12.3581 16.6748Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNo);
export default __webpack_public_path__ + "static/media/notification-no.bf89dc678662cff81dd89bbe6e47d3e3.svg";
export { ForwardRef as ReactComponent };